// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ChatAlt2Icon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "ChatAlt2/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2 5a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H9l-3 3v-3H4a2 2 0 0 1-2-2V5Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15 7v2a4 4 0 0 1-4 4H9.83l-1.767 1.767c.28.149.599.233.938.233h2l3 3v-3h2a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-1Z"
}));
export default ChatAlt2Icon;